import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const defaultValues = {
  firstName: '',
  lastName: '',
  sex: '',
  birthdate: '',
};

const schema = Yup.object().shape({
  firstName: Yup.string().required(FORM_VALIDATION_ERRORS.familyFirstName),
  lastName: Yup.string().required(FORM_VALIDATION_ERRORS.familyLastName),
  sex: Yup.string().required(FORM_VALIDATION_ERRORS.familySex),
  birthdate: capsuleValidation.date(FORM_VALIDATION_ERRORS.familyBirthdate).required(),
});

const validation = {
  schema,
  defaultValues,
};

export default validation;
